import SeoComponents from './SeoComponents';

export default SeoComponents;
